/**
 * helper to create viewport setups
 */
export class StageHelper {
    /**
     * returns the default viewport setup
     */
    static getDefaultSetup() {
        return {
            cameras: [{
                    name: 'default',
                    from: [20, 0, 0],
                    to: [0, 0, 0],
                    up: [0, 0, 1],
                }],
            scenes: [{ name: 'default' }],
            viewports: [{
                    name: 'default',
                    scene: 'default',
                    camera: 'default',
                    navigator: 'default',
                    left: 0,
                    top: 0,
                    width: 1.0,
                    height: 1.0,
                    bgcolor: 0x007fc3,
                }],
        };
    }
    /**
     * creates a split screen with 2 viewports
     * @param splitAt position where to split (from 0 [left] to 1 [right])
     * @param sharedScene if true the same scene will be used but with different cameras
     */
    static create2Viewports(splitAt = 0.5, sharedScene = true) {
        const out = {
            cameras: [
                {
                    name: 'cam1',
                    from: [30, 0, 0],
                    to: [0, 0, 0],
                    up: [0, 0, 1],
                    fov: 30,
                },
                {
                    name: 'cam2',
                    from: [0, 30, 0],
                    to: [0, 0, 0],
                    up: [0, 0, 1],
                    fov: 30,
                },
            ],
            scenes: [
                {
                    name: 'scene1',
                },
            ],
            viewports: [
                {
                    name: 'viewport1',
                    scene: 'scene1',
                    camera: 'cam1',
                    left: 0,
                    top: 0,
                    width: splitAt,
                    height: 1.0,
                    bgcolor: 0x007fc3,
                },
            ],
        };
        let secondScene = 'scene1';
        if (!sharedScene) {
            out.scenes.push({ name: 'scene2' });
            secondScene = 'scene2';
        }
        out.viewports.push({
            name: 'viewport2',
            scene: secondScene,
            camera: 'cam2',
            left: splitAt,
            top: 0,
            width: 1.0 - splitAt,
            height: 1.0,
            bgcolor: 0xf49100,
        });
        return out;
    }
    /**
     * creates a full viewport with a pip (picture in picture) viewport
     */
    static createViewportWithPip(left = false, top = true, factorOfScreen = 0.2, sharedScene = true, margin = 0.1) {
        const out = {
            cameras: [
                {
                    name: 'cam1',
                    from: [30, 0, 0],
                    to: [0, 0, 0],
                    up: [0, 0, 1],
                    fov: 30,
                },
                {
                    name: 'cam2',
                    from: [0, 30, 0],
                    to: [0, 0, 0],
                    up: [0, 0, 1],
                    fov: 30,
                },
            ],
            scenes: [
                {
                    name: 'scene1',
                },
            ],
            viewports: [
                {
                    name: 'viewport1',
                    scene: 'scene1',
                    camera: 'cam1',
                    bgcolor: 0x007fc3,
                },
            ],
        };
        let secondScene = 'scene1';
        if (!sharedScene) {
            out.scenes.push({ name: 'scene2' });
            secondScene = 'scene2';
        }
        const leftPos = left ? margin : (1.0 - margin - factorOfScreen);
        const topPos = top ? margin : (1.0 - margin - factorOfScreen);
        out.viewports.push({
            name: 'viewport2',
            scene: secondScene,
            camera: 'cam2',
            left: leftPos,
            top: topPos,
            width: factorOfScreen,
            height: factorOfScreen,
            bgcolor: 0xf49100,
        });
        return out;
    }
}
//# sourceMappingURL=StageHelper.js.map